import React, { useEffect, useState } from 'react';

const quotes = [
  { q: 'Always on time, tidy and friendly – wouldn’t use anyone else!', a: 'Jane, Altona Meadows' },
  { q: 'Garden looks fantastic after every visit.', a: 'Rahul, Newport' },
  { q: 'Our clients love the transformation!', a: '—' },
];

const Testimonials = ({ withHeading = true }) => {
  const [index, setIndex] = useState(0);
  useEffect(() => {
    const id = setInterval(() => setIndex((i) => (i + 1) % quotes.length), 4000);
    return () => clearInterval(id);
  }, []);

  const current = quotes[index];

  return (
    <section className="section testimonials" id="testimonials">
      <div className="container" style={{ textAlign: 'center' }}>
        {withHeading && <h2 className="section-title">Testimonials</h2>}
        <div className="card" style={{ maxWidth: 720, margin: '0 auto' }}>
          <div className="testimonial-quote">“{current.q}”</div>
          <div className="testimonial-author">{current.a}</div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;


